export interface SelectOption {
  value: string
  label: string
}

export const createDropdownCollection = (
  collection: any[],
  labelName: string,
  valueName: string
): SelectOption[] => {
  return collection.map(element => ({
    label: element[labelName],
    value: element[valueName],
  }))
}

export const createDropdownValue = (
  label: string,
  value: string
): SelectOption => ({
  label,
  value,
})
